<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        搜索广告
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <div class="center_list_head_rig" @click="dialogFormVisible1 = true">添加商品</div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tabData" style="width: 100%" ref="multipleTable">
        <el-table-column width="50"></el-table-column>
        <el-table-column label="商品图片" align="center" width="120">
          <template slot-scope="scope">
            <img width="100px" :src="serve+'/' + scope.row.images" alt>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="商品名称" align="center"></el-table-column>
        <el-table-column label="操作" width="250" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="del(scope.row.p_id)" class="button1">删除</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加消息 -->
    <el-dialog title="添加广告商品" :visible.sync="dialogFormVisible1" width="40%">
      <el-form>
        <el-form-item label="商品Id:">
          <el-input style="width:356px" v-model="p_id" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　排序">
           <el-input style="width:356px" v-model="order_by" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="add()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      tabData: [],
      dialogFormVisible1: false,
      p_id: "",
      order_by:null,
    };
  },
  created() {
    this.$store.state.leftTitle = "搜索广告";
    this.$store.state.topActiveId = 7;
    this.geting();
  },

  methods: {
    geting() {
      this.axios
        .get(this.serve+"/admin/list_search_ad", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.tabData = res.data.data;
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    },
    add() {
      this.axios
        .get(this.serve+"/admin/add_search_ad", {
          params: {
            username: this.username,
            token: this.token,
            id: this.p_id,
            order_by : this.order_by
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "添加成功"
            });
            this.geting();
            this.dialogFormVisible1 = false;
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    del(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve+"/admin/del_search_ad", {
              params: {
                username: this.username,
                token: this.token,
                id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.geting()
              }else if(res.data.status == 'error'){
                 this.$message.error(res.data.msg)
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>